import React, { useEffect, useRef, useState } from 'react';
import { SingleItemContainer, Hook } from '~/src/containers/SingletonHook/SingleItemContainer';

export let mountIntoContainer: <HookReturn = any,
    HookArgs extends any[] = any[]>(
    hook: Hook<HookReturn, HookArgs>
) => void;

export let unmountFromContainer: <HookReturn = any,
    HookArgs extends any[] = any[]>(
    hook: Hook<HookReturn, HookArgs>
) => void;

// компонент будет содержать все экземпляры одноэлементных хуков.
export const SingletonHooksContainer = () => {
    const singletonHooksContainerMounted = useRef(false);
    useEffect(() => {
        if (singletonHooksContainerMounted.current) {
            //  ошибка, если компонент монтируется более одного раза.
            console.log('Вы должны монтировать SingletonHooksContainer перед любым другим компонентом ' +
                'и никогда не размонтировать его .');
        }
        singletonHooksContainerMounted.current = true;
        return () => {
            singletonHooksContainerMounted.current = false;
        };
    }, []);

    // список всех одноэлементных хуков, которые используются в данный момент времени
    const [hooks, setHooks] = useState<Hook[]>([]);

    useEffect(() => {
        // назначаем поведение mountIntoContainer и unmountFromContainer
        // куда добавляем хук в список и соответственно фильтруем хук из списка.
        mountIntoContainer = (newHook: Hook) =>
            setHooks((hooks) => [...hooks, newHook]);
        unmountFromContainer = (hookToUnmount: Hook) =>
            setHooks((hooks) =>
                hooks.filter((hook) => hook.useHookBody !== hookToUnmount.useHookBody));
        setHooks([]);
    }, []);

    return (
        <>
            {/* рендерим SingleItemContainer для каждого хука */}
            {hooks.map((hook, index) => (
                <SingleItemContainer {...hook} key={index}/>
            ))}
        </>
    );
};
